import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetWorkloadReqData } from "./GetWorkloadReqData";
import { AxiosResponse } from "axios";

const ENDPOINT = "/cash_flow/workload/download";

export class DownloadWorkloadReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetWorkloadReqData;

    constructor(downloadType: string, filters: GetWorkloadReqData) {
        super();
        this.endPoint = this.endPoint + "/" + downloadType;
        this.payload = filters;
        this.responseType = "text";
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.payload);
    }
}
